import React, { useEffect, useState } from "react"
import { motion } from 'framer-motion'
import axios from "axios"
import API from "../../Common/API"
import filterIcon from '../../Assets/Icons/filters.svg'
import { useDispatch, useSelector } from "react-redux"
import { setFlawFilter, setInitialLoadingFilter, setOccupationFilter, setStatusFilter, setZodiacSignFilter, setMaxAge, setMinAge } from "../../Store/Auth/actions"
import { useTranslation } from "react-i18next"
import FilterLoader from "../../Components/Loaders/FilterLoader"
import { LuPen } from "react-icons/lu";
import Dialog from '../../Components/Dialog'

const ageNumbers = [
    { text: '20', value: 20 },
    { text: '21', value: 21 },
    { text: '22', value: 22 },
    { text: '23', value: 23 },
    { text: '24', value: 24 },
    { text: '25', value: 25 },
    { text: '26', value: 26 },
    { text: '27', value: 27 },
    { text: '28', value: 28 },
    { text: '29', value: 29 },
    { text: '30', value: 30 },
    { text: '31', value: 31 },
    { text: '32', value: 32 },
    { text: '33', value: 33 },
    { text: '34', value: 34 },
    { text: '35', value: 35 },
    { text: '36', value: 36 },
    { text: '37', value: 37 },
    { text: '38', value: 38 },
    { text: '39', value: 39 },
    { text: '40', value: 40 },
    { text: '41', value: 41 },
    { text: '42', value: 42 },
    { text: '43', value: 43 },
    { text: '44', value: 44 },
    { text: '45', value: 45 },
    { text: '46', value: 46 },
    { text: '47', value: 47 },
    { text: '48', value: 48 },
    { text: '49', value: 49 },
    { text: '50', value: 50 },
    { text: '51', value: 51 },
    { text: '52', value: 52 },
    { text: '53', value: 53 },
    { text: '54', value: 54 },
    { text: '55', value: 55 },
    { text: '56', value: 56 },
    { text: '57', value: 57 },
    { text: '58', value: 58 },
    { text: '59', value: 59 },
    { text: '60', value: 60 },
    { text: '61', value: 61 },
    { text: '62', value: 62 },
    { text: '63', value: 63 },
    { text: '64', value: 64 },
    { text: '65', value: 65 },
    { text: '66', value: 66 },
    { text: '67', value: 67 },
    { text: '68', value: 68 },
    { text: '69', value: 69 },
    { text: '70', value: 70 }
  ];

const Filters = () => {

    const zodiacSigns = useSelector((state) => state.auth.zodiacSigns)
    const flaws = useSelector((state) => state.auth.flaws)
    const tFlawName = useSelector((state) => state.auth.tFlaws)
    const tStatus = useSelector((state) => state.auth.tStatus)
    const occupation = useSelector((state) => state.auth.fullOccupations)
    const status = useSelector((state) => state.auth.status)
    const dispatch = useDispatch()
    // const [loading, setLoading] = useState(true)
    const flawFilter = useSelector((state) => state.auth.flawFilter)
    const occupationFilter = useSelector((state) => state.auth.occupationFilter)
    const zodiacSignFilter = useSelector((state) => state.auth.zodiacSignFilter)
    const statusFilter = useSelector((state) => state.auth.statusFilter)
    const lang = useSelector((state) => state.theme.language)
    const { t } = useTranslation()
    const initialLoading = useSelector((state) => state.auth.initialLoadingFilter)
    const [loading, setLoading] = useState(!initialLoading)
    const [openAge,setOpenAge] = useState(false)
    const minAge =  useSelector((state)=>state.auth.minAge)
    const maxAge = useSelector((state)=>state.auth.maxAge)
    const [min, setMin] = useState(minAge || 20);
    const [max, setMax] = useState(maxAge || 70);
  
    const filteredMaxAges = ageNumbers.filter(age => age.value >= min);

    const pushFilters = (value, key) => {
        if (key === 'flaw') {
            const alreadyExists = flawFilter.some(item => item === value);

            const newFilters = alreadyExists
                ? flawFilter.filter(item => item !== value)
                : [...flawFilter, value];

            dispatch(setFlawFilter(newFilters));
        } else if (key === 'occupation') {
            const alreadyExists = occupationFilter.some(item => item === value);

            const newFilters = alreadyExists
                ? occupationFilter.filter(item => item !== value)
                : [...occupationFilter, value];

            dispatch(setOccupationFilter(newFilters));
        } else if (key === 'zodiacSign') {
            const alreadyExists = zodiacSignFilter.some(item => item === value);

            const newFilters = alreadyExists
                ? zodiacSignFilter.filter(item => item !== value)
                : [...zodiacSignFilter, value];

            dispatch(setZodiacSignFilter(newFilters));
        } else if (key === 'status') {
            const alreadyExists = statusFilter.some(item => item === value);

            const newFilters = alreadyExists
                ? statusFilter.filter(item => item !== value)
                : [...statusFilter, value];

            dispatch(setStatusFilter(newFilters));
        }
    }

    useEffect(() => {
        if (!initialLoading) {
            setTimeout(() => {
                setLoading(false)
                dispatch(setInitialLoadingFilter(true))
            }, 3000)
        }
    }, [])

    const savePreference = ()=>{
        dispatch(setMaxAge(max))
        dispatch(setMinAge(min))
        let values = {
            minAge : min,
            maxAge : max
        }
        API.post('/common/savePreference',values).then((subRes)=>{
            if(subRes.status === 200){
                setOpenAge(false)
            }
        })
    }

    return (
        <>
            {
                loading ? <FilterLoader /> : <motion.div className="w-full h-[85vh] flex flex-col overflow-y-scroll gap-5 px-2 py-2">
                    <p className="flex flex-row justify-start gap-5 font-bold text-primeColor text-xl"><img src={filterIcon} height={20} width={20} />{t(`Filters`)}</p>
                    <motion.div className={`w-full h-full flex flex-row justify-between gap-2`}>
                        <p className="font-bold text-xl">{t('Age')}</p>
                       <motion.div className="flex flex-row gap-2 items-center">
                       <p>{minAge}yrs to {maxAge}yrs</p>
                       <LuPen className="text-primeColor cursor-pointer font-bold" onClick={()=>setOpenAge(true)}/>
                        </motion.div>
                        </motion.div>
                    <motion.div className={`w-full h-full flex flex-col gap-2`}>
                        <p className="font-bold text-xl">{t('Flaws')}</p>
                        <motion.div className="w-full h-full flex flex-col gap-2">
                            {lang === 'en' && flaws && flaws.map((c, i) => {
                                return <motion.div key={i} className="w-full flex flex-row" onClick={() => pushFilters(c, 'flaw')}>
                                    <input type="checkbox" checked={flawFilter.some(item => item === c)} className="w-5 h-5" />
                                    <p className="text-md text-black font-semibold ml-2">{c.text}</p>
                                </motion.div>
                            })}
                            {lang === 'ta' && tFlawName && tFlawName.map((c, i) => {
                                return <motion.div key={i} className="w-full flex flex-row" onClick={() => pushFilters(c, 'flaw')}>
                                    <input type="checkbox" checked={flawFilter.some(item => item === c)} className="w-5 h-5" />
                                    <p className="text-md text-black font-semibold ml-2">{c.text}</p>
                                </motion.div>
                            })}
                        </motion.div>
                    </motion.div>
                    <motion.div className={`w-full h-full flex flex-col gap-2`}>
                        <p className="font-bold text-xl">{t('Occupation')}</p>
                        <motion.div className="w-full h-full flex flex-col gap-2">
                            {occupation.map((c, i) => {
                                return <motion.div key={i} className="w-full flex flex-row" onClick={() => pushFilters(c, 'occupation')}>
                                    <input type="checkbox" checked={occupationFilter.some((item) => item === c)} className="w-5 h-5" />
                                    <p className="text-md text-black font-semibold ml-2">{lang === 'en' ? c.occupation : c.tOccupation}</p>
                                </motion.div>
                            })}
                        </motion.div>
                    </motion.div>
                    <motion.div className={`w-full h-full flex flex-col gap-2`}>
                        <p className="font-bold text-xl">{t('Zodiac Sign')}</p>
                        <motion.div className="w-full h-full flex flex-col gap-2">
                            {zodiacSigns.map((c, i) => {
                                return <motion.div key={i} className="w-full flex flex-row" onClick={() => pushFilters(c, 'zodiacSign')}>
                                    <input type="checkbox" checked={zodiacSignFilter.some((item) => item === c)} className="w-5 h-5" />
                                    <p className="text-md text-black font-semibold ml-2">{c.text}</p>
                                </motion.div>
                            })}
                        </motion.div>
                    </motion.div>
                    <motion.div className={`w-full h-full flex flex-col gap-2`}>
                        <p className="font-bold text-xl">{t('Status')}</p>
                        <motion.div className="w-full h-full flex flex-col gap-2">
                            {lang === 'en' && status && status.map((c, i) => {
                                return <motion.div key={i} className="w-full flex flex-row" onClick={() => pushFilters(c, 'status')}>
                                    <input type="checkbox" checked={statusFilter.some((item) => item === c)} className="w-5 h-5" />
                                    <p className="text-md text-black font-semibold ml-2">{c.text}</p>
                                </motion.div>
                            })}
                            {lang === 'ta' && tStatus && tStatus.map((c, i) => {
                                return <motion.div key={i} className="w-full flex flex-row" onClick={() => pushFilters(c, 'status')}>
                                    <input type="checkbox" checked={statusFilter.some((item) => item === c)} className="w-5 h-5" />
                                    <p className="text-md text-black font-semibold ml-2">{c.text}</p>
                                </motion.div>
                            })}
                        </motion.div>
                    </motion.div>
                </motion.div>
            }
            <Dialog title="Select Age" showDialog={openAge} onClose={() => setOpenAge(false)}>
     <motion.div className="flex flex-col w-full py-2">
     <motion.div className="flex flex-row justify-between my-5 w-full items-center gap-2">
        <select
        className="h-10 w-32"
          value={min}
          onChange={(e) => {
            const newMin = parseInt(e.target.value);
            setMin(newMin);
            if (max < newMin) setMax(newMin); // adjust maxAge if needed
          }}
        >
          {ageNumbers.map((age, index) => (
            <option key={index} value={age.value}>{age.text}</option>
          ))}
        </select>

        <p>To</p>

        <select
        className="h-10 w-32"
          value={max}
          onChange={(e) => setMax(parseInt(e.target.value))}
        >
          {filteredMaxAges.map((age, index) => (
            <option key={index} value={age.value}>{age.text}</option>
          ))}
        </select>
      </motion.div>
      <motion.div className="flex flex-row justify-around w-full">
      <motion.div className="flex flex-row border border-[grey] rounded-full text-black cursor-pointer px-5 py-2" onClick={()=>setOpenAge(false)}>
        Cancel
        </motion.div>
      <motion.div className="flex flex-row bg-primeColor rounded-full text-white cursor-pointer px-5 py-2" onClick={()=>savePreference()}>
        Save
        </motion.div>
        </motion.div>
        </motion.div>
    </Dialog>
        </>
    )
}

export default Filters